import { Trans } from "react-i18next";
import React, { useEffect, useState } from "react";

const MFAModal: React.FC = () => {
  const [show, setShow] = useState(false);
  const [setupUrl, setSetupUrl] = useState<string>("/mfa/setup");

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail || {};
      setSetupUrl(detail.setupUrl || "/mfa/setup");
      setShow(true);
    };

    window.addEventListener("app:mfa-required", handler as EventListener);
    return () => {
      window.removeEventListener("app:mfa-required", handler as EventListener);
    };
  }, []);

  if (!show) {
    return null;
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="mfa-modal-title"
      onClick={() => setShow(false)}
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
        backgroundColor: "rgba(15, 23, 42, 0.55)",
        zIndex: 1300,
      }}
    >
      <div
        className="bg-white rounded shadow p-4"
        style={{ width: "min(28rem, 100%)" }}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
          <h2 id="mfa-modal-title" className="h5 mb-0">
            <Trans ns="features" i18nKey="ui.copy.b8e43856c7b4" /></h2>
          <button
            type="button"
            className="btn btn-link p-0 text-decoration-none"
            onClick={() => setShow(false)}
            aria-label="Dismiss MFA dialog"
          >
            <Trans ns="features" i18nKey="ui.copy.70afe9eff3f2" /></button>
        </div>
        <p>
          <Trans ns="features" i18nKey="ui.copy.ad0712310cf1" /></p>
        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setShow(false)}
          >
            <Trans ns="features" i18nKey="ui.copy.70afe9eff3f2" /></button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              window.location.href = setupUrl;
            }}
          >
            <Trans ns="features" i18nKey="ui.copy.df9560ba4d2b" /></button>
        </div>
      </div>
    </div>
  );
};

export default MFAModal;
